import { render, staticRenderFns } from "./FormVueComponentCrearRegistrosTabla.vue?vue&type=template&id=ce7fe436&"
import script from "./FormVueComponentCrearRegistrosTabla.vue?vue&type=script&lang=js&"
export * from "./FormVueComponentCrearRegistrosTabla.vue?vue&type=script&lang=js&"
import style0 from "./FormVueComponentCrearRegistrosTabla.vue?vue&type=style&index=0&id=ce7fe436&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports